import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountService } from '../../services/account.service';

@Injectable({
  providedIn: 'root'
})

export class RegistrationLoggedInGuard implements CanActivate {

  constructor(private accountService: AccountService, private route: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.accountService.currentUser$.pipe(map(user => {
      if (user && (this.accountService.isAdminWithoutRoom() && !sessionStorage.selectedRoom)) {
        this.route.navigate(['/registration/select-room']);
        return false;
      } else if(user) {
        return true;
      } else {
        this.route.navigate(['/registration/login']);
        return false;
      }
    }))
  }
}
